import { createContext, createSignal, JSX, useContext } from "solid-js";
import de from '../de.json';
import { Session } from "../pages/Account";
import { TenantMembership } from "../models/Tenant";

export interface User {
    username: string;
    id: string;
    language: any;
    loggedin: boolean;
    minecraftUsernameVerified?: boolean;
    permissions?: number;
    uuid?: string;
    minecraftUUID?: string;
    versionNumber?: number;
    sessions?: Session[];
    fifteenMinutesInAddonCount?: number;
    showAdminUiInMemberApp?: boolean;
}

export interface UserContextType {
    user: () => User;
    setUser: (u: User | ((prev: User) => User)) => void;
    switchLanguage: (lang: any) => void;
    userTenant: () => TenantMembership | null;
    setUserTenant: (t: TenantMembership | null) => void;
    sessionChecked: () => boolean;
    setSessionChecked: (checked: boolean) => void;
}

export const UserContext = createContext<UserContextType | null>(null);

export function useUserContext(): UserContextType {
    const ctx = useContext(UserContext);
    if (!ctx) throw new Error('useUserContext must be used within a Provider');
    return ctx;
}

const [user, setUser] = createSignal<User>({
    username: "",
    id: "",
    language: de,
    loggedin: false
});

const switchLanguage = (newLanguage: any) => {
    setUser(prev => ({ ...prev, language: newLanguage }));
};

export const [userTenant, setUserTenant] = createSignal<TenantMembership | null>(null);

const [sessionChecked, setSessionChecked] = createSignal(false);

export const Provider = (props: { children: JSX.Element }) => {
    return (
        <UserContext.Provider value={{
            user, setUser, switchLanguage,
            userTenant, setUserTenant,
            sessionChecked, setSessionChecked,
        }}>
            {props.children}
        </UserContext.Provider>
    );
};
